import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";

export default function GroupedAssetTableSkeleton({ count = 5 }) {
  return [...Array(count)].map((_, index) => (
    <TableRow key={`skeleton-${index}`}>
      <TableCell>
        <Skeleton variant="text" width={200} height={24} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width={200} height={24} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width={200} height={24} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={120} height={24} />
      </TableCell>
    </TableRow>
  ));
}
